// components/PaginatedBookGrid.js
import React, { useEffect, useState, useCallback } from 'react';
import styles from "./PaginatedBookGrid.module.css";
import { useNavigate } from 'react-router';


const PaginatedBookGrid = () => {
  const [books, setBooks] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const navigate = useNavigate();

  const fetchBooks = useCallback(async () => {
  if (isLoading || !hasMore) return;

  setIsLoading(true);
  try {
    const response = await fetch("https://snsapiv2.baganit.com/api/app/home_page_books_v2", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        version_code: 70,
        platform: "Android",
        page_no: pageNo,
      }),
    });

    const result = await response.json();

    if (result.status === 1) {
      // ✅ Check if result already exists to avoid duplication
      const newItems = result.result.filter(
        (item) => !books.some((existing) => existing.item_id === item.item_id)
      );

      setBooks((prev) => [...prev, ...newItems]);

      if (result.current_page < result.total_pages) {
        setPageNo((prev) => prev + 1);
      } else {
        setHasMore(false);
      }
    }
  } catch (error) {
    console.error("Error fetching books", error);
  } finally {
    setIsLoading(false);
  }
}, [pageNo, isLoading, hasMore, books]);


  // useEffect(() => {
  //   fetchBooks();
  // }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop + 100 >=
        document.documentElement.offsetHeight
      ) {
        fetchBooks();
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [fetchBooks]); // include fetchBooks only if it's memoized
  

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [handleScroll]);

  const handleClick = (item) => {
      navigate(`/audio/book-series/${item.item_id}`);
  };

  return (
    <div style={{ padding: '16px' }} >
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        {books.map(book => (
          <div key={book.item_id} style={{ textAlign: 'center' }} onClick={() => handleClick(book)}>
            <img
              src={book.image}
              alt={book.title}
              style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
            />
            <div style={{ marginTop: '8px', fontSize: '14px' }}>{book.title}</div>
          </div>
        ))}
      </div>
      {isLoading && (
  <div style={{ textAlign: 'center', marginTop: '20px' }}>
    <div className={styles.spinner}></div>
  </div>
)}

    </div>
  );
};

export default PaginatedBookGrid;
